import React from 'react';
import { Helmet } from 'react-helmet';

export interface ITitleProps {
    children: string;
    titleSuffix?: string;
}

export const Title: React.FunctionComponent<ITitleProps> = props => {
    const titleSuffix = props.titleSuffix ?? 'axesCheck';
    const titleSeparator = ' – ';
    const title = `${props.children}${titleSeparator}${titleSuffix}`;

    return (
        <Helmet>
            <title id="title">{title}</title>
        </Helmet>
    );
};
